import { Link } from 'react-router';
import { StateMessage } from '../shared/components/state-message';
import { Wordmark } from '../shared/components/wordmark';
import { ROUTES } from '../shared/constants/app.constant';

export function NotFoundPage() {
  return (
    <main className="mx-auto flex min-h-dvh max-w-md flex-col justify-center gap-6 px-5">
      <Wordmark />
      <StateMessage
        title="Halaman ini tidak ada di buku kas"
        description="Alamatnya mungkin salah ketik atau sudah dipindah."
        action={
          <Link to={ROUTES.dashboard} className="text-sm font-medium text-ink underline underline-offset-4">
            Ke Ringkasan
          </Link>
        }
      />
    </main>
  );
}
